import { PureComponent, type ReactNode } from "react";
import { RepareoLogoIcon, RepareoOldLogoIcon } from "@App/Components/common/Icons";

export type LoaderProps = {
  loaderSizeClass?: string;
  logoSizeClass?: string;
};

const isB2bPath = (): boolean => window.location.pathname.startsWith("/partner/");

export class Loader extends PureComponent<LoaderProps> {
  render(): ReactNode {
    const b2b = isB2bPath();
    const loaderSize = this.props.loaderSizeClass ?? "h-32 w-32";
    const logoSize = this.props.logoSizeClass ?? "w-14 h-14";

    return (
      <div className="flex justify-center items-center relative">
        <div className={`animate-spin rounded-full ${loaderSize} border-b-2 border-primary`} />
        <div className="absolute">
          {b2b ? (
            <RepareoLogoIcon className={logoSize} />
          ) : (
            <RepareoOldLogoIcon className={logoSize} />
          )}
        </div>
      </div>
    );
  }
}
